import {
	IsInterface,
	TypeGuard,
	UnionOf,
	isArray,
	isLikeObject,
	isOptional,
	isSingletonString,
	isSingletonStringUnion,
	isString,
	isUnknown
} from "generic-type-guard";

import { Localizable, ValueConversionConfig } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { isMap } from "../utilities/typeGuardUtils";

function isLazyType<T>(tgProvider: () => TypeGuard<T>): TypeGuard<T> {
	return (value): value is T => tgProvider()(value);
}

const isBasePlaceholder = new IsInterface().withProperties({ value: isUnknown }).get();

export const isLocalizable: TypeGuard<Localizable> = new IsInterface()
	.withProperties({ key: isString })
	.withOptionalProperties({
		args: isMap(
			new UnionOf(
				new IsInterface()
					.with(isBasePlaceholder)
					.withProperties({
						type: isSingletonString("plain")
					})
					.get()
			)
				.with(
					new IsInterface()
						.with(isBasePlaceholder)
						.withProperties({
							type: isSingletonString("formattable"),
							// CANDO: Improve check
							properties: isLikeObject({
								formattingConfig: (x): x is ValueConversionConfig => true
							})
						})
						.get()
				)
				.with(
					new IsInterface()
						.with(isBasePlaceholder)
						.withProperties({
							type: isSingletonString("localizable"),
							properties: isArray(isLazyType(() => isLocalizable))
						})
						.get()
				)
				.with(
					new IsInterface()
						.with(isBasePlaceholder)
						.withProperties({
							type: isSingletonString("dataFormat"),
							properties: isLikeObject({
								type: isSingletonStringUnion("date", "dateRange", "decimalSeparator")
							})
						})
						.get()
				)
				.get()
		),
		defaults: isMap(isOptional(isString))
	})
	.get();
